import { Button, ButtonAppearance } from '@atlassian/learning-components';
import { FunctionComponent } from 'react';
import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { useSendScreenEventEffect } from 'hooks/useScreenEvent';
import {
  trackErrorScreenView,
  trackUnifiedProfileErrorRecoveryClick,
} from 'analytics/errorAnalytics';

export type PageError = {
  image: string;
  heading: string;
  description: string;
  link: string;
  linkText: string;
};

export const PageError: FunctionComponent<PageError> = ({
  image,
  heading,
  description,
  link,
  linkText,
}: {
  image: string;
  heading: string;
  description: string;
  link: string;
  linkText: string;
}) => {
  useSendScreenEventEffect(() => trackErrorScreenView(heading, description));

  const handleErrorRecoveryClick = () => {
    trackUnifiedProfileErrorRecoveryClick(heading, linkText, link);
    window.open(link, '_self');
  };

  return (
    <div css={containerStyles}>
      <img src={image} alt="Error" css={dangerTriangleStyles} />
      <h1 css={headingStyles}>{heading}</h1>
      <p css={descriptionStyles}>{description}</p>
      <Button
        label={linkText}
        appearance={ButtonAppearance.LINK}
        onClick={handleErrorRecoveryClick}
      />
    </div>
  );
};

const containerStyles = css({
  maxWidth: '800px',
  minWidth: '375px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: token('space.600'),
});

const dangerTriangleStyles = css({
  marginBottom: token('space.300'),
});

const headingStyles = css({
  marginBottom: token('space.200'),
  fontFamily: token('font.family.brand.heading'),
  fontSize: '24px',
  fontWeight: token('font.weight.semibold'),
  lineHeight: '32px',
  textAlign: 'center',
});

const descriptionStyles = css({
  marginBottom: token('space.200'),
  color: token('color.text'),
  fontFamily: 'Inter',
  fontWeight: '400',
  lineHeight: '20px',
  textAlign: 'center',
  fontSize: '16px',
});
